import { useEffect, useState } from "react";
import { BsPersonFill, BsPersonPlusFill } from "react-icons/bs";
import { FaCrown } from "react-icons/fa";
import { toast } from "react-toastify";
import TextField from "../../components/Input/TextField";
import { HiXCircle } from "react-icons/hi";
import AddUser from "./components/AddUser";

const API_URL = process.env.REACT_APP_API_URL;

const UsersTable = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [confirmAction, setConfirmAction] = useState(null);
  const [addUser, setAddUser] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/users`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${JSON.parse(localStorage.getItem("user"))?.token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => setUsers(data))
      .catch((err) => console.error("Hata:", err));
  }, [addUser]);

  const handleDelete = async (id, mail) => {
    try {
      const res = await fetch(`${API_URL}/user/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem("user")).token}`,
        },
      });

      const data = await res.json();
      if (res.ok) {
        setUsers((prev) => prev.filter((u) => u._id !== id));
        toast.success(mail + " mailine sahip kullanıcı silindi!");
        setSelectedUser(null);
        setConfirmAction(null);
      } else {
        toast.error("Silme başarısız: " + data.error);
      }
    } catch (err) {
      toast.error("Bir Hata Oluştu: " + err);
    }
  };

  const handleUpdate = async (userData) => {
    try {
      const res = await fetch(`${API_URL}/users/${userData._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${JSON.parse(localStorage.getItem("user")).token}`,
        },
        body: JSON.stringify(userData),
      });

      const data = await res.json();
      if (res.ok) {
        setUsers((prev) =>
          prev.map((u) => (u._id === userData._id ? { ...u, ...userData } : u))
        );
        toast.success("Kullanıcı güncellendi!");
        setSelectedUser(null);
        setConfirmAction(null);
      } else {
        toast.error("Güncelleme başarısız: " + data.error);
      }
    } catch (err) {
      toast.error("Bir Hata Oluştu: " + err);
    }
  };

  const handleAdminChange = () => {
    if (!selectedUser) return;
    const updatedUser = { ...selectedUser, isAdmin: !selectedUser.isAdmin };
    handleUpdate(updatedUser);
  };

  return (
    <div className="p-6">
      <h1 className="text-xl font-bold mb-4">Kullanıcı Listesi</h1>
      {
        addUser && <AddUser setAddUser={setAddUser} addUser={addUser}/>
      }
      <div className="xl:w-9/12 w-full mx-auto justify-end flex">
        <button onClick={() => setAddUser(true)} className="btn bg-sky-600 mr-0 text-md gap-2"><BsPersonPlusFill className="text-xl" /> Kullanıcı Ekle</button>
      </div>
      <table className="table border border-gray-400 w-full xl:w-9/12 mx-auto">
        <thead>
          <tr className="bg-gray-500 text-white">
            <th className="text-center">#</th>
            <th className="text-center">Kullanıcı Adı</th>
            <th className="text-center">Email</th>
            <th className="text-center">Admin</th>
          </tr>
        </thead>
        <tbody>
          {users?.map((u, index) => (
            <tr
              key={u._id}
              className="hover:bg-gray-700 cursor-pointer"
              onClick={() => setSelectedUser(u)}
            >
              <td className="text-center">{index + 1}</td>
              <td className="text-center">{u.username}</td>
              <td className="text-center">{u.email}</td>
              <td className="text-2xl text-center">
                {u.isAdmin ? (
                  <FaCrown className="text-yellow-500 mx-auto" />
                ) : (
                  <BsPersonFill className="mx-auto" />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedUser && (
        <dialog open className="modal modal-open">
          <div className="modal-box bg-gray-800 text-white">
            <HiXCircle
              className="text-3xl justify-self-end cursor-pointer hover:text-red-600"
              onClick={() => setSelectedUser(null)}
            />
            <h3 className="font-bold text-lg mb-4">Kullanıcı Detayları</h3>
            {selectedUser.isAdmin ? (
              <div className="flex mx-auto w-max items-center gap-2 font-bold italic">
                <FaCrown className="text-yellow-500" /> Admin
              </div>
            ) : (
                <div className="flex mx-auto w-max items-center gap-2 font-bold italic">
                   <BsPersonFill /> Kullanıcı
                </div>
            )}
            <div className="space-y-3 mt-4">
              <TextField
                label={"Kullanıcı Adı"}
                type="text"
                value={selectedUser.username}
                onChange={(e) =>
                  setSelectedUser({ ...selectedUser, username: e.target.value })
                }
              />
              <TextField
                label={"Email"}
                type="email"
                value={selectedUser.email}
                onChange={(e) =>
                  setSelectedUser({ ...selectedUser, email: e.target.value })
                }
              />
            </div>

            <div className="modal-action justify-between">
              {selectedUser.isAdmin ? (
                <button
                  className="btn bg-red-500 border-none"
                  onClick={() => setConfirmAction("removeAdmin")}
                >
                  Admin Yetkisini Al
                </button>
              ) : (
                <button
                  className="btn bg-yellow-600 border-none"
                  onClick={() => setConfirmAction("makeAdmin")}
                >
                  Admin Yetkisi Ver
                </button>
              )}

              <div className="space-x-2">
                <button
                  className="btn bg-red-600 border-none"
                  onClick={() => setConfirmAction("delete")}
                >
                  Sil
                </button>
                <button
                  className="btn bg-green-600 border-none"
                  onClick={() => handleUpdate(selectedUser)}
                >
                  Kaydet
                </button>
              </div>
            </div>
          </div>
          <div
            className="modal-backdrop cursor-pointer"
            onClick={() => setSelectedUser(null)}
          ></div>
        </dialog>
      )}

      {confirmAction && (
        <dialog open className="modal modal-open">
          <div className="modal-box">
            <h3 className="font-bold text-lg">Emin misiniz?</h3>
            <p className="py-4">
              {confirmAction === "makeAdmin" &&
                "Bu kullanıcıya admin yetkisi vermek üzeresiniz."}
              {confirmAction === "removeAdmin" &&
                "Bu kullanıcının admin yetkisini kaldırmak üzeresiniz."}
              {confirmAction === "delete" &&
                "Bu kullanıcıyı silmek üzeresiniz. Bu işlem geri alınamaz!"}
            </p>
            <div className="modal-action">
              <button className="btn" onClick={() => setConfirmAction(null)}>
                Vazgeç
              </button>
              <button
                className={`btn ${
                  confirmAction === "delete" ? "bg-red-600" : "bg-green-600"
                }`}
                onClick={() => {
                  if (confirmAction === "makeAdmin" || confirmAction === "removeAdmin") {
                    handleAdminChange();
                  } else if (confirmAction === "delete") {
                    handleDelete(selectedUser._id, selectedUser.email);
                  }
                }}
              >
                Onayla
              </button>
            </div>
          </div>
          <div
            className="modal-backdrop cursor-pointer"
            onClick={() => setConfirmAction(null)}
          ></div>
        </dialog>
      )}
    </div>
  );
};

export default UsersTable;